import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import * as actionTypes from '../../actions/school-candidate/types';
import { stateKeys, stateLoadingKeys } from '../../constants/school-candidate-references';

const initialState = Immutable.fromJS({
  [stateKeys.schoolCandidateReferencesLoading]: false,
  [stateKeys.schoolCandidateReferencesSummaries]: null,
  [stateKeys.selectedSchoolCandidateReference]: null,
  [stateKeys.selectedSchoolCandidateReferenceId]: null,
  [stateKeys.schoolCandidateReferences]: new Map(),
});

export default reducerCreator(initialState, {
  [actionTypes.SCHOOL_CANDIDATE_CANDIDATE_SET_REFERENCES_LOADING]: (state, {isLoading, part}) => {
    if (stateLoadingKeys[part]) {
      return state.set(stateLoadingKeys[part], isLoading);
    }

    return state;
  },
  [actionTypes.SCHOOL_CANDIDATE_SET_CANDIDATE_REFERENCES_SUMMARIES]: (state, {schoolCandidateReferencesSummaries}) => state.set(stateKeys.schoolCandidateReferencesSummaries, schoolCandidateReferencesSummaries),
  [actionTypes.SCHOOL_CANDIDATE_ADD_CANDIDATE_REFERENCE_TO_CACHE]: (state, {candidateReferenceId, candidateReference}) => {
    var cache = state.get(stateKeys.schoolCandidateReferences);
    cache.set(candidateReferenceId, candidateReference);
    return state;
  },
  [actionTypes.SCHOOL_CANDIDATE_GET_CANDIDATE_REFERENCE_FROM_CACHE]: (state, {candidateReferenceId}) => {
    var cache = state.get(stateKeys.schoolCandidateReferences);
    return cache.get(candidateReferenceId);
  },
  [actionTypes.SCHOOL_CANDIDATE_SET_SELECTED_CANDIDATE_REFERENCE]: (state, {candidateReference}) => state.set(stateKeys.selectedSchoolCandidateReference, candidateReference),
  [actionTypes.SCHOOL_CANDIDATE_RESET_CANDIDATE_REFERENCES]: () => initialState
});



// WEBPACK FOOTER //
// ./src/reducers/school/school-candidate-references.js